import classNames from 'classnames';
import { Icon, IconName, Typography } from '@canvas-logic/clp-shared-ui';
import { MouseEventHandler } from 'react';
import styles from './MenuList.module.css';

interface IMenuListItemProps {
  className?: string;
  icon: IconName;
  label: string;
  loading?: boolean;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const MenuListItem = ({ className, icon, label, loading, disabled, onClick }: IMenuListItemProps) => {
  return (
    <button
      type="button"
      className={classNames(styles.item, className)}
      onClick={onClick}
      disabled={disabled || loading}
    >
      <Icon type={loading ? 'spinner' : icon} />
      <Typography variant="button" color="inherit">
        {label}
      </Typography>
    </button>
  );
};
